module.exports = __webpack_public_path__ + "img/bell-checked.f1db6149.svg";